import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { PrinterOutlined } from "@ant-design/icons";
import { Button } from "antd";
import toast from "react-hot-toast";
import { get_delivery_note } from "../../../../Controllers/Sales/DO";
import Header from "../../../../Componets/Header";
import headers from "../../../../Data/Forms/Sales/DO/headers";
import Loadercomponent from "../../../../Componets/Loader";
import ScrollWrapper from "../../../../Componets/ScrollWrapper";
import A4Invoice from "./a4Invoice";

const DeliveryNoteView = () => {
    let { id } = useParams();
    let navigate = useNavigate();
    let [searchParams] = useSearchParams();

    const deliveryNoteA4Ref = useRef();

    const handleA4Print = useReactToPrint({
        content: () => deliveryNoteA4Ref.current,
    });

    const [loader, setLoader] = useState(false);
    const [values, setValues] = useState();
    const [header, setHeader] = useState(headers);
    const [returnPage, setReturnPage] = useState(1);

    const handleData = (delivery_note) => {
        setValues(delivery_note);
        setLoader(false);
    };

    const fetchData = async () => {
        if (id) {
            setLoader(true);

            const data = { id };

            const delivery_note = await get_delivery_note(data);

            if (delivery_note?.status) {
                handleData(delivery_note?.data);
            } else {
                toast?.error(delivery_note?.message);
                setLoader(false);
            }
        } else {
            setLoader(false);
        }
    };

    useEffect(() => {
        fetchData();
        const pageParam = searchParams.get("returnPage");
        if (pageParam) {
            setReturnPage(parseInt(pageParam));
        }
    }, [id, searchParams]);

    const handleBack = () => {
        const page = returnPage || 1;
        navigate(`/app/delivery-notes?page=${page}`);
    };

    return (
        <Header headers={header} setHeaders={setHeader}>
            <Loadercomponent loader={loader}>

                <div className="pb-8">
                    <div className="flex justify-end flex-wrap">
                        <div className="p-2" onClick={handleBack}>
                            <Button size="large">
                                <div className="flex">
                                    <div>Back</div>
                                </div>
                            </Button>
                        </div>
                        <div className="p-2" onClick={handleA4Print}>
                            <Button size="large">
                                A4 Print <PrinterOutlined className="text-lg" />
                            </Button>
                        </div>
                    </div>
                </div>

                <ScrollWrapper>
                    <div>
                        <A4Invoice ref={deliveryNoteA4Ref} values={values} />
                    </div>
                </ScrollWrapper>

            </Loadercomponent>
        </Header>
    );
};

export default DeliveryNoteView;